import * as React from 'react';
import { UIText1, IconTrain16, IconWalk16 } from '@cian/ui-kit';

import { ETransportType } from '../../../../types/offer';
import * as styles from './time.css';

const iconByTransportType = {
  transport: <IconTrain16 color="gray_icons_100" />,
  walk: <IconWalk16 color="gray_icons_100" />,
};

export const Time = ({ type, time }: { type: ETransportType; time: string }) => {
  return (
    <div className={styles['time']}>
      <div className={styles['icon']}>{iconByTransportType[type]}</div>
      <UIText1 color="gray60_100">{time}</UIText1>
    </div>
  );
};
